// Keep in sync with the active login route block in src/router/routes.js

// Classic login — comment SSO lines above and uncomment below to switch
const LOGIN_ROUTE_PATH = "/login"
const LOGIN_ROUTE_NAME = "Login"

export const LOGIN_PAGE_PATHS = [
  "/sso-login",
  "/old-login",
  "/login",
  "/kiosk/login",
  "/kiosk/launch"
]

export const isLoginPagePath = (pathname = "") =>
  LOGIN_PAGE_PATHS.some(
    (path) => pathname === path || pathname.startsWith(`${path}/`)
  )

export { LOGIN_ROUTE_PATH, LOGIN_ROUTE_NAME }
